import RenProcessDetail from './src/ren-process-detail'

RenProcessDetail.install = function (Vue) {
  Vue.component(RenProcessDetail.name, RenProcessDetail)
}

export default RenProcessDetail
